module.exports = __webpack_public_path__ + "img/004.d6206275.png";